export default __webpack_public_path__ + "static/media/rates_photo.7af13064.jpg";